module.exports = __webpack_public_path__ + "static/media/backlight6.327e669b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Backlight/backlight6.jpg
// module id = 317
// module chunks = 0